module.exports = __webpack_public_path__ + "media/images/lb/148-87c04a0c7d406a485820e5bf5c7e6d66.svg";